import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import AdminInterestsPage from '../../../components/admin/Interests/interestsList';

export default function Interests() {
    useEffect(() => {
        document.title = 'Interests | CWP Employee Portal';
    }, []);    

    return (
        <div className="admin-page-wrap">
            <div className="admin-top-bar-wrap">
                <div className="admin-top-bar-left">
                    <Link
                        className="admin-top-bar-back"
                        to={'/siteadmin'}
                    >
                        Back
                    </Link>
                </div>
            </div>
            <AdminInterestsPage />          
        </div>
    );
}